// extracted by css-extract-rspack-plugin
export default {"cls1":"SubtopicsBar-cls1_6lV","cls2":"SubtopicsBar-cls2_l5H SubtopicsBar-cls1_6lV"};